var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c("h1", { class: _vm.$style.header }, [
        _vm._v("\n    Duo 2 Factor Authentication\n  "),
      ]),
      _vm._v(" "),
      _c("Alert", {
        class: [_vm.$style.alertPositionWidth, _vm.$style.alertPosition],
        model: {
          value: _vm.errorMessage,
          callback: function ($$v) {
            _vm.errorMessage = $$v
          },
          expression: "errorMessage",
        },
      }),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          class: [
            _vm.$style.frameContainerColor,
            _vm.$style.frameContainerPosition,
            _vm.$style.frameContainerSize,
            _vm.$style.frameContainerWidth,
          ],
          attrs: {
            enterClass: _vm.$style.fadeTo,
            enterActiveClass: _vm.$style.fadeInTransition,
            leaveActiveClass: _vm.$style.fadeOutTransition,
            leaveToClass: _vm.$style.fadeTo,
            tag: "div",
          },
        },
        [
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showFrame,
                expression: "!showFrame",
              },
            ],
            key: "loading",
            class: [
              "jc-progress",
              "jc-spin",
              _vm.$style.spinAnimation,
              _vm.$style.loadingIcon,
            ],
          }),
          _vm._v(" "),
          _c("iframe", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFrame,
                expression: "showFrame",
              },
            ],
            key: "frame",
            class: _vm.$style.frame,
            attrs: { id: "duo_iframe" },
          }),
        ]
      ),
      _vm._v(" "),
      _c("form", { attrs: { id: "duo_form", method: "POST" } }, [
        _vm.isSso
          ? _c("input", {
              attrs: { name: "context", type: "hidden", value: "sso" },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isSso
          ? _c("input", {
              attrs: { name: "redirect_to", type: "hidden" },
              domProps: { value: _vm.redirectTo },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "ChooseMfa",
        _vm._b(
          { attrs: { selectedFactor: _vm.factor } },
          "ChooseMfa",
          _vm.$props,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }